import { Box, Grid, Skeleton, Stack, Typography } from "@mui/material";
import styles from "./caseAssignmentPreferenceStyles";

export default function CaseAssignmentPreferenceSkeleton() {
  return (
    <>
      <Box sx={styles.sliderContainer}>
        <Box sx={styles.sliderPlaceholder}><Skeleton animation="wave" variant="rounded" height="0.25rem" /></Box>
      </Box>
      <Grid container spacing={2}>
        {[0, 1, 2].map((index) => (
          <Grid size={4} key={index}>
            <Stack spacing={1} sx={[styles.option, { alignItems: "center" }]}>
              <Typography variant="subtitle1" sx={styles.optionLabel}><Skeleton animation="wave" width="5rem" /></Typography>
              <Skeleton animation="wave" variant="circular" width={24} height={24} />
              <Typography variant="caption" sx={styles.optionDescription}><Skeleton animation="wave" width="9rem" /></Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
